<template>
  <div>
    <div
      class="form-group variable-selector">
      <grid-row column-align="left" col-spaced>
        <grid-col col-size="1">
          <vue-single-select
            :placeholder="''"
            class="selection-left"
            v-model="symbolOp"
            v-on:input="updateModel"
            :options="operators"
            :hidden="hideOperator"
          />
        </grid-col>
        <grid-col col-size="2" class="center-wrapper">
          <vue-single-select
            :placeholder="''"
            class="selection-left"
            v-model="variable"
            v-on:input="updateModel"
            :options="variables"
            :disabled="disabled"/>
        </grid-col>
        <grid-col col-size="2">
          <vue-single-select
            :placeholder="''"
            class="selection-left"
            v-model="op"
            :option-label="'label'"
            v-on:input="updateModel"
            :options="variableOperations"
          />
        </grid-col>
      </grid-row>
    </div>
  </div>
</template>

<script>

import VariableSelectorModal from '@/components/variable/VariableSelectorModal';
import vSelect from 'vue-select';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import BtnPill from '@/components/shared/buttons/BtnPill';
import VueSingleSelect from 'vue-single-select';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';

export default {
  name: 'FormulaFieldSelector',
  components: {
    GridCol,
    GridRow,
    BtnPill,
    vSelect,
    VariableSelectorModal,
    FontAwesomeIcon,
    VueSingleSelect
  },
  props: {
    value: {
      type: Object,
      default: () => {
      }
    },
    variables: {
      type: Array,
      default: () => []
    },
    operators: {
      type: Array,
      default: () => []
    },
    variableOperations: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hideOperator: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      variable: null,
      symbolOp: null,
      op: null
    };
  },
  watch: {
    value: {
      handler: function (value) {
        if (this.value == null) {
          return;
        }
        this.variable = value.variable;
        this.symbolOp = value.symbolOp;
        this.op = value.op;
      }
    }
  },
  methods: {
    updateModel () {
      const model = {
        variable: this.variable,
        symbolOp: this.symbolOp,
        op: this.op
      };
      this.$emit('input', model);
    }
  }
};
</script>

<style scoped>

.center-wrapper {
  display: flex;
  align-items: center;
}

</style>



// WEBPACK FOOTER //
// src/brand/health/components/challenge/FormulaFieldSelector.vue